var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpdesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "806px",
    height: "594px",
    viewBox: "0 0 806 594",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.33661417 0.314952885 52.4990078 0.314952885 52.4990078 16.7208683 0.33661417 16.7208683"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 103.591797 69.9675895 103.591797 69.9675895 0 47.3080138 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M763.04696,359.470405 C763.04696,160.9349 603.083299,5.68434189e-14 405.765904,5.68434189e-14 C208.448509,5.68434189e-14 48.4848485,160.9349 48.4848485,359.470405 C48.4848485,412.357489 59.9267743,462.53057 80.3185906,507.751947 L731.213218,507.751947 C751.605034,462.53057 763.04696,412.357489 763.04696,359.470405",
    id: "Fill-1",
    fill: "#F0F2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "coding-screen",
    transform: "translate(175.334743, 147.654649)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#434B58",
    points: "0 236.134725 387.315011 236.134725 387.315011 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#92C2FC",
    points: "47.4081545 28.70907 88.1233931 28.70907 88.1233931 23.2070751 47.4081545 23.2070751"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#ED9C95",
    points: "68.0446453 47.130928 95.931795 47.130928 95.931795 41.6289331 68.0446453 41.6289331"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#7AD389",
    points: "158.956753 47.130928 313.282287 47.130928 313.282287 41.6289331 158.956753 41.6289331"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#92C2FC",
    points: "116.568286 47.130928 148.359636 47.130928 148.359636 41.6289331 116.568286 41.6289331"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#BC7DC6",
    points: "77.5262762 62.200287 133.300576 62.200287 133.300576 56.7044327 77.5262762 56.7044327"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#FFD07E",
    points: "100.951482 83.4164058 172.342585 83.4164058 172.342585 77.9144109 100.951482 77.9144109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#C27ACD",
    points: "47.9658975 103.512978 126.049917 103.512978 126.049917 98.0109832 47.9658975 98.0109832"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#92C2FC",
    points: "134.973805 103.512978 190.748104 103.512978 190.748104 98.0109832 134.973805 98.0109832"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#ED9C95",
    points: "68.0446453 124.167789 172.342585 124.167789 172.342585 118.665794 68.0446453 118.665794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#92C2FC",
    points: "215.288796 124.167789 284.448927 124.167789 284.448927 118.665794 215.288796 118.665794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#D1D1D1",
    points: "177.362272 124.167789 210.269109 124.167789 210.269109 118.665794 177.362272 118.665794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#7AD389",
    points: "102.066968 144.264361 194.094562 144.264361 194.094562 138.762366 102.066968 138.762366"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#A1A1A1",
    points: "77.5262762 144.264361 97.047281 144.264361 97.047281 138.762366 77.5262762 138.762366"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#92C2FC",
    points: "47.9658975 159.33679 110.433113 159.33679 110.433113 153.834795 47.9658975 153.834795"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#FFD07E",
    points: "115.4528 159.33679 136.647034 159.33679 136.647034 153.834795 115.4528 153.834795"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#ED9C95",
    points: "142.224464 159.33679 244.849174 159.33679 244.849174 153.834795 142.224464 153.834795"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#67D2CF",
    points: "251.54209 159.33679 344.127427 159.33679 344.127427 153.834795 251.54209 153.834795"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#FFD07E",
    points: "68.0446453 179.433363 100.951482 179.433363 100.951482 173.931368 68.0446453 173.931368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#4A90E2",
    points: "110.433113 179.433363 187.401646 179.433363 187.401646 173.931368 110.433113 173.931368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#C27ACD",
    points: "85.3346781 199.529935 147.801893 199.529935 147.801893 194.02794 85.3346781 194.02794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#ED9C95",
    points: "160.629982 199.529935 223.097198 199.529935 223.097198 194.02794 160.629982 194.02794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#7AD389",
    points: "233.136572 199.529935 291.699586 199.529935 291.699586 194.02794 233.136572 194.02794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#F5A623",
    points: "332.414825 83.4164058 349.704857 83.4164058 349.704857 77.9144109 332.414825 77.9144109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#D9D9D9",
    points: "178.477758 83.4164058 303.04868 83.4164058 303.04868 77.9144109 178.477758 77.9144109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#FFD07E",
    points: "100.951482 28.70907 266.601151 28.70907 266.601151 23.2070751 100.951482 23.2070751"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#FFFFFF",
    points: "20.0787478 24.0042392 29.0026357 24.0042392 29.0026357 15.0724292 20.0787478 15.0724292"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#FFFFFF",
    points: "20.0787478 45.7755259 29.0026357 45.7755259 29.0026357 36.8437159 20.0787478 36.8437159"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#FFFFFF",
    points: "20.0787478 69.779765 29.0026357 69.779765 29.0026357 60.8479551 20.0787478 60.8479551"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#FFFFFF",
    points: "20.0787478 91.5510517 29.0026357 91.5510517 29.0026357 82.6192418 20.0787478 82.6192418"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#FFFFFF",
    points: "20.0787478 114.438815 29.0026357 114.438815 29.0026357 105.507005 20.0787478 105.507005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#FFFFFF",
    points: "20.0787478 137.326578 29.0026357 137.326578 29.0026357 128.394768 20.0787478 128.394768"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#FFFFFF",
    points: "20.0787478 159.656102 29.0026357 159.656102 29.0026357 150.724292 20.0787478 150.724292"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#FFFFFF",
    points: "20.0787478 182.543865 29.0026357 182.543865 29.0026357 173.612055 20.0787478 173.612055"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#FFFFFF",
    points: "20.0787478 204.87339 29.0026357 204.87339 29.0026357 195.94158 20.0787478 195.94158"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#FFFFFF",
    points: "20.0787478 227.761153 29.0026357 227.761153 29.0026357 218.829343 20.0787478 218.829343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "browser-window",
    transform: "translate(175.334743, 76.645161)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "0 73.295778 388.946133 73.295778 388.946133 2.84217094e-14 0 2.84217094e-14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.63777308
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    stroke: "#4550E6",
    points: "0 73.295778 388.946133 73.295778 388.946133 2.84217094e-14 0 2.84217094e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-4",
    stroke: "#4550E6",
    points: "0 307.144213 388.946133 307.144213 388.946133 73.295778 0 73.295778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3589565,36.647889 C48.3589565,42.0653047 43.9578166,46.4473258 38.5339053,46.4473258 C33.1049748,46.4473258 28.7088542,42.0672773 28.7088542,36.647889 C28.7088542,31.2335067 33.1069597,26.8484522 38.5339053,26.8484522 C43.9558297,26.8484522 48.3589565,31.2354813 48.3589565,36.647889 Z",
    id: "Stroke-5",
    stroke: "#F2877E",
    fill: "#F2877E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3959441,36.647889 C90.3959441,42.0653047 85.9948042,46.4473258 80.5708929,46.4473258 C75.1419624,46.4473258 70.7458418,42.0672773 70.7458418,36.647889 C70.7458418,31.2335067 75.1439473,26.8484522 80.5708929,26.8484522 C85.9928173,26.8484522 90.3959441,31.2354813 90.3959441,36.647889 Z",
    id: "Stroke-6",
    stroke: "#F9BA53",
    fill: "#F9BA53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.432932,36.647889 C132.432932,42.0653047 128.031792,46.4473258 122.607881,46.4473258 C117.17895,46.4473258 112.782829,42.0672773 112.782829,36.647889 C112.782829,31.2335067 117.180935,26.8484522 122.607881,26.8484522 C128.029805,26.8484522 132.432932,31.2354813 132.432932,36.647889 Z",
    id: "Stroke-7",
    stroke: "#7FCE8C",
    fill: "#7FCE8C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dev-desk",
    transform: "translate(236.222692, 173.578748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customer-service-man"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6475429,335.724339 L534.129765,335.724339",
    id: "Stroke-3",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.542799263,335.724339 L16.7121013,335.724339",
    id: "Stroke-5",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.065207,335.724339 L563.234509,335.724339",
    id: "Stroke-7",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.557541,410.397122 C116.557541,415.77651 168.680903,420.142389 232.976515,420.142389 C297.26566,420.142389 349.39549,415.77651 349.39549,410.397122 C349.39549,405.017735 297.26566,400.651855 232.976515,400.651855 C168.680903,400.651855 116.557541,405.017735 116.557541,410.397122",
    id: "Fill-9",
    fill: "#F0F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.745907,183.661143 C274.026493,183.661143 228.849463,229.035106 228.849463,285.011919 L228.849463,312.31166 C228.849463,363.695204 210.688103,370.770268 190.534685,370.770268 L174.520608,370.770268 L174.520608,405.853229 L190.534685,405.853229 C218.72748,405.853229 267.655788,382.263186 267.655788,335.687307 L391.842495,335.687307 C391.842495,365.345403 370.078614,370.770268 353.521249,370.770268 L345.268437,370.770268 L337.507172,370.770268 L337.507172,405.853229 L345.268437,405.853229 L353.521249,405.853229 C385.381242,405.853229 430.648819,399.025045 430.648819,335.68081 L430.648819,285.011919 C430.648819,229.035106 385.47179,183.661143 329.745907,183.661143",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.745907,183.661143 C274.026493,183.661143 228.849463,229.035106 228.849463,285.011919 L228.849463,312.31166 C228.849463,363.695204 210.688103,370.770268 190.534685,370.770268 L174.520608,370.770268 L174.520608,405.853229 L190.534685,405.853229 C218.72748,405.853229 267.655788,382.263186 267.655788,335.687307 L391.842495,335.687307 C391.842495,365.345403 370.078614,370.770268 353.521249,370.770268 L337.507172,370.770268 L337.507172,405.853229 L353.521249,405.853229 C385.381242,405.853229 430.648819,399.025045 430.648819,335.68081 L430.648819,285.011919 C430.648819,229.035106 385.47179,183.661143 329.745907,183.661143 Z",
    id: "Stroke-13",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFFFFF",
    points: "353.033583 187.5599 329.74332 203.152327 306.465993 187.5599 306.465993 168.069366 353.033583 168.069366"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-17",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "353.033583 187.5599 329.74332 203.152327 306.465993 187.5599 306.465993 168.069366 353.033583 168.069366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.726937,221.138191 L378.33854,196.196805 C370.829517,192.038824 362.712527,188.913842 354.194539,186.782877 L329.746554,203.148429 L351.904965,222.229661 C354.595537,224.542538 358.683137,224.035784 360.726937,221.138191",
    id: "Fill-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.726937,221.138191 L378.33854,196.196805 C370.829517,192.038824 362.712527,188.913842 354.194539,186.782877 L329.746554,203.148429 L351.904965,222.229661 C354.595537,224.542538 358.683137,224.035784 360.726937,221.138191 Z",
    id: "Stroke-25",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.771992,221.138191 L281.160389,196.196805 C288.669412,192.038824 296.786402,188.913842 305.30439,186.782877 L329.752375,203.148429 L307.593964,222.229661 C304.903392,224.542538 300.815792,224.035784 298.771992,221.138191",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.771992,221.138191 L281.160389,196.196805 C288.669412,192.038824 296.786402,188.913842 305.30439,186.782877 L329.752375,203.148429 L307.593964,222.229661 C304.903392,224.542538 300.815792,224.035784 298.771992,221.138191 Z",
    id: "Stroke-29",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.658375,288.911325 L267.658375,335.688607",
    id: "Stroke-31",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.839908,288.911325 L391.839908,335.688607",
    id: "Stroke-33",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.508466,401.959021 L325.866568,401.959021 C317.296838,401.959021 310.344038,394.974913 310.344038,386.366593 C310.344038,377.751777 317.296838,370.774166 325.866568,370.774166 L337.508466,370.774166 L337.508466,401.959021 Z",
    id: "Fill-35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.508466,401.959021 L325.866568,401.959021 C317.296838,401.959021 310.344038,394.974913 310.344038,386.366593 C310.344038,377.751777 317.296838,370.774166 325.866568,370.774166 L337.508466,370.774166 L337.508466,401.959021 Z",
    id: "Stroke-37",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.520608,401.959021 L162.878711,401.959021 C154.308981,401.959021 147.362648,394.974913 147.362648,386.366593 C147.362648,377.751777 154.308981,370.774166 162.878711,370.774166 L174.520608,370.774166 L174.520608,401.959021 Z",
    id: "Fill-39",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.520608,401.959021 L162.878711,401.959021 C154.308981,401.959021 147.362648,394.974913 147.362648,386.366593 C147.362648,377.751777 154.308981,370.774166 162.878711,370.774166 L174.520608,370.774166 L174.520608,401.959021 Z",
    id: "Stroke-41",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.730888,97.901495 L395.730888,82.3090679 C395.730888,45.7123422 366.192807,16.0412528 329.760136,16.0412528 C293.327465,16.0412528 263.789384,45.7123422 263.789384,82.3090679 L263.789384,97.901495 C257.36047,97.901495 252.147487,103.137952 252.147487,109.595815 L252.147487,113.493922 C252.147487,119.951786 257.36047,125.188242 263.789384,125.188242 C264.158044,125.188242 264.500833,125.11028 264.863026,125.084293 C270.321782,156.145707 297.266307,179.761737 329.760136,179.761737 C362.253966,179.761737 389.192023,156.145707 394.657247,125.084293 C395.019439,125.11028 395.362228,125.188242 395.730888,125.188242 C402.159803,125.188242 407.372786,119.951786 407.372786,113.493922 L407.372786,109.595815 C407.372786,103.137952 402.159803,97.901495 395.730888,97.901495",
    id: "Fill-43",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.730888,97.901495 L395.730888,82.3090679 C395.730888,45.7123422 366.192807,16.0412528 329.760136,16.0412528 C293.327465,16.0412528 263.789384,45.7123422 263.789384,82.3090679 L263.789384,97.901495 C257.36047,97.901495 252.147487,103.137952 252.147487,109.595815 L252.147487,113.493922 C252.147487,119.951786 257.36047,125.188242 263.789384,125.188242 C264.158044,125.188242 264.500833,125.11028 264.863026,125.084293 C270.321782,156.145707 297.266307,179.761737 329.760136,179.761737 C362.253966,179.761737 389.192023,156.145707 394.657247,125.084293 C395.019439,125.11028 395.362228,125.188242 395.730888,125.188242 C402.159803,125.188242 407.372786,119.951786 407.372786,113.493922 L407.372786,109.595815 C407.372786,103.137952 402.159803,97.901495 395.730888,97.901495 Z",
    id: "Stroke-45",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.715076,125.189542 C298.715076,129.49695 295.24191,132.985755 290.953811,132.985755 C286.67218,132.985755 283.192546,129.49695 283.192546,125.189542 C283.192546,120.882134 286.67218,117.393328 290.953811,117.393328 C295.24191,117.393328 298.715076,120.882134 298.715076,125.189542",
    id: "Fill-47",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.327726,125.189542 C376.327726,129.49695 372.85456,132.985755 368.566461,132.985755 C364.28483,132.985755 360.805196,129.49695 360.805196,125.189542 C360.805196,120.882134 364.28483,117.393328 368.566461,117.393328 C372.85456,117.393328 376.327726,120.882134 376.327726,125.189542",
    id: "Fill-49",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35568,140.781319 C322.101061,151.176271 337.416624,151.176271 349.162005,140.781319",
    id: "Stroke-51",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.687122,105.699008 C362.688596,101.88536 359.176624,99.2021633 354.985541,99.2021633 C350.794458,99.2021633 347.282485,101.88536 345.28396,105.699008",
    id: "Stroke-53",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.233726,104.39834 C312.2352,100.584692 308.729695,97.901495 304.532144,97.901495 C300.341061,97.901495 296.835557,100.584692 294.830563,104.39834",
    id: "Stroke-55",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.427401,109.597764 C275.427401,109.597764 279.314501,97.02637 276.805025,81.9861747 C283.628471,84.273064 294.830563,74.5148034 294.830563,74.5148034 L294.830563,58.9223764 C294.830563,58.9223764 317.765101,66.7185899 329.756256,66.7185899 C341.753878,66.7185899 364.688416,58.9223764 364.688416,58.9223764 L364.688416,74.5148034 C364.688416,74.5148034 375.896976,84.273064 382.713954,81.9861747 C380.204478,97.02637 384.091578,109.597764 384.091578,109.597764 C384.091578,101.996456 391.26428,96.6170688 399.200174,98.7805181 C399.251916,98.7090528 399.290722,98.618097 399.348931,98.533638 C398.197677,98.156821 397.001149,97.903444 395.733475,97.903444 L395.733475,82.311017 C395.733475,45.7142912 366.188927,16.0432019 329.756256,16.0432019 C293.330052,16.0432019 263.785503,45.7142912 263.785503,82.311017 L263.785503,97.903444 C262.51783,97.903444 261.314834,98.156821 260.176515,98.533638 C260.228257,98.618097 260.267063,98.7090528 260.325273,98.7805181 C268.254699,96.6170688 275.427401,101.996456 275.427401,109.597764",
    id: "Fill-57",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.427401,109.597764 C275.427401,109.597764 279.314501,97.02637 276.805025,81.9861747 C283.628471,84.273064 294.830563,74.5148034 294.830563,74.5148034 L294.830563,58.9223764 C294.830563,58.9223764 317.765101,66.7185899 329.756256,66.7185899 C341.753878,66.7185899 364.688416,58.9223764 364.688416,58.9223764 L364.688416,74.5148034 C364.688416,74.5148034 375.896976,84.273064 382.713954,81.9861747 C380.204478,97.02637 384.091578,109.597764 384.091578,109.597764 C384.091578,101.996456 391.26428,96.6170688 399.200174,98.7805181 C399.251916,98.7090528 399.290722,98.618097 399.348931,98.533638 C398.197677,98.156821 397.001149,97.903444 395.733475,97.903444 L395.733475,82.311017 C395.733475,45.7142912 366.188927,16.0432019 329.756256,16.0432019 C293.330052,16.0432019 263.785503,45.7142912 263.785503,82.311017 L263.785503,97.903444 C262.51783,97.903444 261.314834,98.156821 260.176515,98.533638 C260.228257,98.618097 260.267063,98.7090528 260.325273,98.7805181 C268.254699,96.6170688 275.427401,101.996456 275.427401,109.597764 Z",
    id: "Stroke-59",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.377167,105.699008 L244.377167,86.2084741 C244.377167,38.8464768 282.594929,0.45012512 329.744614,0.45012512 C376.900766,0.45012512 415.118528,38.8464768 415.118528,86.2084741 L415.118528,101.800901",
    id: "Stroke-63",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.895816,132.987055 L244.379754,132.987055 C240.085187,132.987055 236.612021,129.498249 236.612021,125.190841 L236.612021,101.802201 C236.612021,97.4947925 240.085187,94.005987 244.379754,94.005987 L259.895816,94.005987 L259.895816,132.987055 Z",
    id: "Fill-65",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.895816,132.987055 L244.379754,132.987055 C240.085187,132.987055 236.612021,129.498249 236.612021,125.190841 L236.612021,101.802201 C236.612021,97.4947925 240.085187,94.005987 244.379754,94.005987 L259.895816,94.005987 L259.895816,132.987055 Z",
    id: "Stroke-67",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.133258,125.189542 C252.133258,129.49695 255.612891,132.985755 259.894523,132.985755 C264.182622,132.985755 267.655788,129.49695 267.655788,125.189542 L267.655788,101.800901 C267.655788,97.4934932 264.182622,94.0046876 259.894523,94.0046876 C255.612891,94.0046876 252.133258,97.4934932 252.133258,101.800901 L252.133258,125.189542 Z",
    id: "Fill-69",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.133258,125.189542 C252.133258,129.49695 255.612891,132.985755 259.894523,132.985755 C264.182622,132.985755 267.655788,129.49695 267.655788,125.189542 L267.655788,101.800901 C267.655788,97.4934932 264.182622,94.0046876 259.894523,94.0046876 C255.612891,94.0046876 252.133258,97.4934932 252.133258,101.800901 L252.133258,125.189542 Z",
    id: "Stroke-71",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.602466,132.987055 L415.118528,132.987055 C419.413095,132.987055 422.886261,129.498249 422.886261,125.190841 L422.886261,101.802201 C422.886261,97.4947925 419.413095,94.005987 415.118528,94.005987 L399.602466,94.005987 L399.602466,132.987055 Z",
    id: "Fill-73",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.602466,132.987055 L415.118528,132.987055 C419.413095,132.987055 422.886261,129.498249 422.886261,125.190841 L422.886261,101.802201 C422.886261,97.4947925 419.413095,94.005987 415.118528,94.005987 L399.602466,94.005987 L399.602466,132.987055 Z",
    id: "Stroke-75",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.358557,125.189542 C407.358557,129.49695 403.885391,132.985755 399.60376,132.985755 C395.315661,132.985755 391.842495,129.49695 391.842495,125.189542 L391.842495,101.800901 C391.842495,97.4934932 395.315661,94.0046876 399.60376,94.0046876 C403.885391,94.0046876 407.358557,97.4934932 407.358557,101.800901 L407.358557,125.189542 Z",
    id: "Fill-77",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.358557,125.189542 C407.358557,129.49695 403.885391,132.985755 399.60376,132.985755 C395.315661,132.985755 391.842495,129.49695 391.842495,125.189542 L391.842495,101.800901 C391.842495,97.4934932 395.315661,94.0046876 399.60376,94.0046876 C403.885391,94.0046876 407.358557,97.4934932 407.358557,101.800901 L407.358557,125.189542 Z",
    id: "Stroke-79",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.832704,390.906588 L271.294527,390.906588 L240.404693,294.70781 C239.544486,292.024613 237.054413,290.205497 234.25389,290.205497 L224.4941,290.205497 L256.832704,390.906588 Z",
    id: "Fill-85",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.832704,390.906588 L271.294527,390.906588 L240.404693,294.70781 C239.544486,292.024613 237.054413,290.205497 234.25389,290.205497 L224.4941,290.205497 L256.832704,390.906588 Z",
    id: "Stroke-87",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.712148,390.906588 L256.832704,390.906588 L224.4941,290.205497 L107.260192,290.205497 C105.190522,290.205497 103.250206,291.199514 102.027806,292.8757 C100.811875,294.558383 100.469086,296.715335 101.102922,298.696873 L130.712148,390.906588 Z",
    id: "Fill-89",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.712148,390.906588 L263.300424,390.906588 L263.300424,407.1487 L143.64759,407.1487 C136.507226,407.1487 130.712148,401.327527 130.712148,394.155011 L130.712148,390.906588 Z",
    id: "Fill-91",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.712148,390.906588 L263.300424,390.906588 L263.300424,407.1487 L143.64759,407.1487 C136.507226,407.1487 130.712148,401.327527 130.712148,394.155011 L130.712148,390.906588 Z",
    id: "Stroke-93",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.300424,390.906588 L321.82683,390.906588 C323.611921,390.906588 325.06069,392.361882 325.06069,394.155011 C325.06069,401.327527 319.27208,407.1487 312.125249,407.1487 L263.300424,407.1487 L263.300424,390.906588 Z",
    id: "Fill-95",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.300424,390.906588 L321.82683,390.906588 C323.611921,390.906588 325.06069,392.361882 325.06069,394.155011 C325.06069,401.327527 319.27208,407.1487 312.125249,407.1487 L263.300424,407.1487 L263.300424,390.906588 Z",
    id: "Stroke-97",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.664581,336.971084 C184.619307,332.930046 187.943716,330.993987 188.092473,330.890037 C186.223302,328.154866 183.319295,327.778049 182.28446,327.732571 C179.807323,327.479194 177.45954,329.194361 176.198335,329.194361 C174.950065,329.194361 173.009749,327.765055 170.959481,327.804036 C168.262441,327.849514 165.772369,329.382769 164.381809,331.806092 C161.581286,336.691719 163.67036,343.922708 166.399738,347.885783 C167.732088,349.828339 169.323148,352.004782 171.412221,351.92682 C173.43015,351.842361 174.186874,350.620954 176.618737,350.620954 C179.0506,350.620954 179.72971,351.92682 181.857591,351.881342 C184.024277,351.848858 185.395434,349.912798 186.721317,347.963745 C188.260634,345.715837 188.881535,343.539394 188.920342,343.422451 C188.875068,343.40296 184.703388,341.798239 184.664581,336.971084",
    id: "Fill-99",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.664581,336.971084 C184.619307,332.930046 187.943716,330.993987 188.092473,330.890037 C186.223302,328.154866 183.319295,327.778049 182.28446,327.732571 C179.807323,327.479194 177.45954,329.194361 176.198335,329.194361 C174.950065,329.194361 173.009749,327.765055 170.959481,327.804036 C168.262441,327.849514 165.772369,329.382769 164.381809,331.806092 C161.581286,336.691719 163.67036,343.922708 166.399738,347.885783 C167.732088,349.828339 169.323148,352.004782 171.412221,351.92682 C173.43015,351.842361 174.186874,350.620954 176.618737,350.620954 C179.0506,350.620954 179.72971,351.92682 181.857591,351.881342 C184.024277,351.848858 185.395434,349.912798 186.721317,347.963745 C188.260634,345.715837 188.881535,343.539394 188.920342,343.422451 C188.875068,343.40296 184.703388,341.798239 184.664581,336.971084 Z",
    id: "Stroke-101",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.220054,319.441298 L182.136996,316.511221",
    id: "Stroke-103",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.712148,390.906588 L256.832704,390.906588 L224.4941,290.205497 L107.260192,290.205497 C105.190522,290.205497 103.250206,291.199514 102.027806,292.8757 C100.811875,294.558383 100.469086,296.715335 101.102922,298.696873 L130.712148,390.906588 Z",
    id: "Stroke-105",
    stroke: "#4550E6",
    strokeWidth: 6.05488756,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(458.350951, 278.965844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1269205,15.107137 L10.2260323,15.107137 L10.2260323,7.56117123 C10.2260323,4.57887257 12.5601319,2.15816243 15.4420503,2.15816243 L52.9128591,2.15816243 C55.792821,2.15816243 58.1269205,4.57887257 58.1269205,7.56117123 L58.1269205,15.107137 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(8.073183, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2759257,12.80841 L48.5596963,12.80841 L48.5596963,7.48355443 C48.5596963,5.68773611 47.0883634,4.22643298 45.2802194,4.22643298 L7.55737221,4.22643298 C5.74725856,4.22643298 4.2759257,5.68773611 4.2759257,7.48355443 L4.2759257,12.80841 Z M52.4990078,16.7208683 L0.33661417,16.7208683 L0.33661417,7.48355443 C0.33661417,3.53197164 3.57669791,0.313974771 7.55737221,0.313974771 L45.2802194,0.313974771 C49.2608937,0.313974771 52.4990078,3.53197164 52.4990078,7.48355443 L52.4990078,16.7208683 Z",
    id: "Fill-3",
    fill: "#4550E6",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#F0F2FF",
    points: "56.6314643 101.973175 13.3361252 101.973175 6.45854673 19.9630025 63.5090428 19.9630025"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fillOpacity: 0.91,
    fill: "#757DE9",
    points: "7.55892138 32.3724364 62.4067032 32.3724364 63.5090428 19.4234619 6.45854673 19.4234619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1330301,99.6736894 L54.8345594,99.6736894 L61.3875826,21.7229472 L8.58000696,21.7229472 L15.1330301,99.6736894 Z M58.4521899,103.591797 L11.5153996,103.591797 L4.30569782,17.80484 L65.6618917,17.80484 L58.4521899,103.591797 Z",
    id: "Fill-10",
    fill: "#4550E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7241465,25.8979491 L2.78362646,25.8979491 C2.43472763,25.8979491 2.15284891,25.6109396 2.15284891,25.2576972 L2.15284891,11.4290571 C2.15284891,11.0758146 2.43472763,10.7908121 2.78362646,10.7908121 L67.7241465,10.7908121 C68.0730453,10.7908121 68.3529529,11.0758146 68.3529529,11.4290571 L68.3529529,25.2576972 C68.3529529,25.6109396 68.0730453,25.8979491 67.7241465,25.8979491",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93253089,23.5522755 L66.0350586,23.5522755 L66.0350586,12.5969451 L3.93253089,12.5969451 L3.93253089,23.5522755 Z M67.3740854,27.516571 L2.59350412,27.516571 C1.16402914,27.516571 0,26.3451217 0,24.9021181 L0,11.2451204 C0,9.80608116 1.16402914,8.63264972 2.59350412,8.63264972 L67.3740854,8.63264972 C68.8035604,8.63264972 69.9675895,9.80608116 69.9675895,11.2451204 L69.9675895,24.9021181 C69.9675895,26.3451217 68.8035604,27.516571 67.3740854,27.516571 Z",
    id: "Fill-14",
    fill: "#4550E6",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "books",
    transform: "translate(175.334743, 494.248577)",
    stroke: "#4550E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.63777308
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.216093,60.3797462 L7.73950926,60.3797462 C3.58421424,60.3797462 0.211800884,57.0046039 0.211800884,52.8459464 C0.211800884,48.6872889 3.58421424,45.3121466 7.73950926,45.3121466 L137.216093,45.3121466 C141.371388,45.3121466 144.743802,48.6872889 144.743802,52.8459464 C144.743802,57.0046039 141.371388,60.3797462 137.216093,60.3797462 Z",
    id: "Stroke-143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23826,45.3121466 L13.761676,45.3121466 C9.60638093,45.3121466 6.23396758,41.9370043 6.23396758,37.7783468 C6.23396758,33.6196893 9.60638093,30.244547 13.761676,30.244547 L143.23826,30.244547 C147.393555,30.244547 150.765968,33.6196893 150.765968,37.7783468 C150.765968,41.9370043 147.393555,45.3121466 143.23826,45.3121466 Z",
    id: "Stroke-147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.216093,30.244547 L7.73950926,30.244547 C3.58421424,30.244547 0.211800884,26.8694046 0.211800884,22.7107472 C0.211800884,18.5520897 3.58421424,15.1769473 7.73950926,15.1769473 L137.216093,15.1769473 C141.371388,15.1769473 144.743802,18.5520897 144.743802,22.7107472 C144.743802,26.8694046 141.371388,30.244547 137.216093,30.244547 Z",
    id: "Stroke-151",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23826,15.1769473 L13.761676,15.1769473 C9.60638093,15.1769473 6.23396758,11.801805 6.23396758,7.64314753 C6.23396758,3.48449004 9.60638093,0.109347723 13.761676,0.109347723 L143.23826,0.109347723 C147.393555,0.109347723 150.765968,3.48449004 150.765968,7.64314753 C150.765968,11.801805 147.393555,15.1769473 143.23826,15.1769473 Z",
    id: "Stroke-155",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.849894,127.137789 C126.849894,115.187717 117.387212,105.501314 105.713143,105.501314 C103.016867,105.501314 100.467526,106.065352 98.1018556,106.997894 C95.4129258,89.8135543 80.9764586,76.6451613 63.4249471,76.6451613 C45.8807825,76.6451613 31.4443153,89.8135543 28.7553855,106.997894 C26.3897151,106.065352 23.8403745,105.501314 21.144098,105.501314 C9.4700286,105.501314 0,115.187717 0,127.137789 C0,139.095382 9.4700286,148.781784 21.144098,148.781784 L105.713143,148.781784 C117.387212,148.781784 126.849894,139.095382 126.849894,127.137789 Z",
    id: "Stroke-11",
    stroke: "#4550E6",
    strokeWidth: 5.63777308,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.790698,55.0011664 C762.790698,43.0510941 753.328016,33.364692 741.653946,33.364692 C738.95767,33.364692 736.408329,33.9287293 734.042659,34.8612712 C731.353729,17.6769319 716.917262,4.5085389 699.365751,4.5085389 C681.821586,4.5085389 667.385119,17.6769319 664.696189,34.8612712 C662.330518,33.9287293 659.781178,33.364692 657.084901,33.364692 C645.410832,33.364692 635.940803,43.0510941 635.940803,55.0011664 C635.940803,66.9587591 645.410832,76.6451613 657.084901,76.6451613 L741.653946,76.6451613 C753.328016,76.6451613 762.790698,66.9587591 762.790698,55.0011664 Z",
    id: "Stroke-11",
    stroke: "#4550E6",
    strokeWidth: 5.63777308,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpdesk);
export default __webpack_public_path__ + "static/media/helpdesk.066b7258322cdedbeb1483b8db76ed35.svg";
export { ForwardRef as ReactComponent };